import React, {memo, useCallback, useMemo, useState, useEffect} from "react"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"
import {CustomizedRange} from "../../../../components/CustomizedRange/RangeComponent"
import "./index.scss"
import {useDispatch, useSelector} from "react-redux"
import {useRPC} from "../../../../hooks/rpc"
import {useMessage} from "../../../../hooks/message"
import {useLocalization} from "../../../../hooks/localization"
import {SettingSelectComponent} from "../../../../components/Settings/SettingSelectComponent"
import {SelectItem} from "../../../../components/Select"
import iconScreen from "../../../../assets/images/icons/screen-brightness.png"
import iconScreenSleep from "../../../../assets/images/icons/screen-brightness-sleep.png"
import iconScreenSleepTime from "../../../../assets/images/icons/screen-sleep-time.png"
import {setEntityListAction} from "../../../../store/control/actions"
import {SettingCheckBoxComponent} from "../../../../components/Settings/SettingCheckboxComponent"

export const ScreenEditScreen = memo(function ScreenEditScreen() {
    const {t} = useLocalization()
    const [rpc] = useRPC()
    const dispatch = useDispatch()
    const {failure} = useMessage()
    const screen = useSelector(state => state.control.screenStateList)


    const saverTimeList = useMemo<SelectItem<number>[]>(
        () => [
            {
                value: 1,
                label: "1 Dakika"
            },
            {
                value: 5,
                label: "5 Dakika"
            },
            {
                value: 30,
                label: "30 Dakika"
            },
            {
                value: 60,
                label: "1 Saat"
            }
        ],
        []
    )

    const optionWallpaper = useMemo<SelectItem<string>[]>(
        () => [
            {
                value: "analog-clock",
                label: "Analog"
            },
            {
                value: "digital-clock",
                label: "Dijital"
            },
            {
                value: "slider",
                label: "Slayt"
            }
        ],
        []
    )

    /*const optionScreenRotation = useMemo<SelectItem<string>[]>(
        () => [
            {
                value: "vertical",
                label: "Yatay"
            },
            {
                value: "horizontal",
                label: "Dikey"
            }
        ],
        []
    )*/

    const [selectScreenTime, setSelectScreenTime] = useState<SelectItem<number>>(
        saverTimeList.find(timeOption => timeOption.value === screen.screen_lock_timing_minute)
    )

    const [selectScreenType, setSelectScreenType] = useState<SelectItem<string>>(
        optionWallpaper.find(screenType => screenType.value === screen.screen_saver_type)
    )

    /*const [selectRotationType, setSelectRotationType] = useState<SelectItem<string>>(
        optionScreenRotation.find(rotateOption => rotateOption.value === screen.screen_rotate)
    )*/

    const [selectScreenSaverTime, setSelectScreenSaverTime] = useState<SelectItem<number>>(() =>
        saverTimeList.find(timeOption => timeOption.value === screen.screen_saver_timing_minute)
    )

    const onScreenBrightnessChange = useCallback(
        (value: number) => {
            console.log(value)
            rpc.updateScreenBrightness(value)
                .then(() =>
                    dispatch(
                        setEntityListAction(
                            {
                                ...screen,
                                screen_standard_brightness: value
                            },
                            "screenState"
                        )
                    )
                )
                .catch(failure)
        },
        [screen, dispatch, failure, rpc]
    )

    const onScreenSleepBrightnessChange = useCallback(
        (value: number) => {
            rpc.updateScreenSleepBrightness(value)
                .then(() =>
                    dispatch(
                        setEntityListAction(
                            {
                                ...screen,
                                screen_saver_active_brightness: value
                            },
                            "screenState"
                        )
                    )
                )
                .catch(failure)
        },
        [screen, dispatch, failure, rpc]
    )

    const onScreenSleepTimeChange = useCallback(
        (value: number) => {
            console.log(value)
            rpc.updateScreenSleepTime(value)
                .then(() =>
                    dispatch(
                        setEntityListAction(
                            {
                                ...screen,
                                screen_sleep_second: value
                            },
                            "screenState"
                        )
                    )
                )
                .catch(failure)
        },
        [screen, dispatch, failure, rpc]
    )

    const onScreenLockTimeChange = useCallback(
        (time: SelectItem<number>) => {
            setSelectScreenTime(time)
            rpc.updateScreenPinCodeTime(time.value)
                .then(() =>
                    dispatch(setEntityListAction({...screen, screen_lock_timing_minute: time.value}, "screenState"))
                )
                .catch(failure)
        },
        [screen, dispatch, failure, rpc]
    )

    const onScreenSaverTimeChange = useCallback(
        (time: SelectItem<number>) => {
            setSelectScreenSaverTime(time)
            rpc.updateScreenSaverTime(time.value)
                .then(() =>
                    dispatch(
                        setEntityListAction(
                            {
                                ...screen,
                                screen_saver_timing_minute: time.value
                            },
                            "screenState"
                        )
                    )
                )
                .catch(failure)
        },
        [screen, dispatch, failure, rpc]
    )

    const onScreenSaverTypeChange = useCallback(
        (type: SelectItem<string>) => {
            setSelectScreenType(type)
            rpc.updateScreenSaverType(type.value)
                .then(() => dispatch(setEntityListAction({...screen, screen_saver_type: type.value}, "screenState")))
                .catch(failure)
        },
        [screen, dispatch, failure, rpc]
    )

    /*const onRotateTypeChange = useCallback(
        (type: SelectItem<string>) => {
            setSelectRotationType(type)
            rpc.updateRotateType(type.value)
                .then(() => dispatch(setEntityListAction({...screen, screen_rotate: type.value}, "screenState")))
                .catch(failure)
        },
        [screen, dispatch, failure, rpc]
    )*/

    const onScreenSaverStateChange = useCallback(() => {
        const newValue = !screen.screen_saver_status
        rpc.updateScreenSaverState(newValue)
            .then(() => dispatch(setEntityListAction({...screen, screen_saver_status: newValue}, "screenState")))
            .catch(failure)
    }, [screen, dispatch, failure, rpc])

    const onScreenPinCodeStateChange = useCallback(() => {
        const newValue = !screen.screen_lock_status
        rpc.updateScreenPinCodeState(newValue)
            .then(() => dispatch(setEntityListAction({...screen, screen_lock_status: newValue}, "screenState")))
            .catch(failure)
    }, [screen, dispatch, failure, rpc])

    return (
        <PasswordContainer requiredRole="default" isFullscreen={true}>
            <SettingsPageContainer buttons={[]} className="service-edit" backUrl={"/settings/custom-menu"}>
                <div className="content-divider">
                    <div className="content-wrapper">
                        <SettingCheckBoxComponent
                            label={"Ekran Koruyucu"}
                            set={onScreenSaverStateChange}
                            value={screen.screen_saver_status}
                        />
                        <SettingCheckBoxComponent
                            label={"PIN Kilidi"}
                            set={onScreenPinCodeStateChange}
                            value={screen.screen_lock_status}
                        />
                        <SettingSelectComponent
                            label={"Kilit Süresi"}
                            options={saverTimeList}
                            value={selectScreenTime}
                            onChange={onScreenLockTimeChange}
                        />
                        <SettingSelectComponent
                            label={"Ekran Koruyucu Süresi"}
                            options={saverTimeList}
                            value={selectScreenSaverTime}
                            onChange={onScreenSaverTimeChange}
                        />
                        <SettingSelectComponent
                            label={"Ekran Koruyucu Tipi"}
                            options={optionWallpaper}
                            value={selectScreenType}
                            onChange={onScreenSaverTypeChange}
                        />
                        {/*<SettingSelectComponent
                            label={"Ekran Yönü"}
                            options={optionScreenRotation}
                            value={selectRotationType}
                            onChange={onRotateTypeChange}
                        />*/}
                    </div>
                    <div className="content-wrapper">
                        <CustomizedRange
                            columnProps={{min: 12}}
                            name={"Ekran Parlaklıklığı"}
                            value={screen.screen_standard_brightness}
                            onChange={onScreenBrightnessChange}
                            activeImage={iconScreen}
                            passiveImage={iconScreen}
                            minValue={10}
                            maxValue={90}
                            stepValue={5}
                            valueType={""}
                        />
                        <CustomizedRange
                            columnProps={{min: 12}}
                            name={"Ekran Uyku Parlaklığı"}
                            value={screen.screen_saver_active_brightness}
                            onChange={onScreenSleepBrightnessChange}
                            activeImage={iconScreenSleep}
                            passiveImage={iconScreenSleep}
                            minValue={0}
                            maxValue={20}
                            stepValue={5}
                            valueType={""}
                        />
                        <CustomizedRange
                            columnProps={{min: 12}}
                            name={"Ekran Uyku Süresi"}
                            value={screen.screen_sleep_second}
                            onChange={onScreenSleepTimeChange}
                            activeImage={iconScreenSleepTime}
                            passiveImage={iconScreenSleepTime}
                            minValue={5}
                            maxValue={60}
                            stepValue={5}
                            valueType={""}
                        />
                    </div>
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
